import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyCommunitiesAdminCommunities: BaseKeyFunction = () => [
  "communities-admin-communities",
];
